import React, { Component } from 'react';
import Header from './../common/Header';
import Loader from './../common/Loader';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Card, Button, CardBody } from 'reactstrap';
import { fetchArticles } from '../../actions/Articles/ArticleAction';

class Articles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    componentWillMount() {
        const { users } = this.props;
        this.props.fetchArticles(users);
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 400);
    }

    renderArticles() {
       return this.props.articles.map((article, index) => {
           return (
               <div className="col-xs-6 col-sm-4" style={{ paddingTop: 15, paddingBottom: 15 }} key={index}>
                   <Card style={{ boxShadow: `0px 5px 15px 0px rgba(0,0,0,0.05)` }}>
                       <div style={{ backgroundImage: `url(${article.picture})`, backgroundSize: 'cover', height: '200px' }} />
                       <CardBody style={{ height: '100px' }}>
                           <a href={article.url} target="_blank" rel='noopener noreferrer'>
                               {
                                   article.title.length < 80 ?
                                       <span style={{ fontFamily: 'Source Sans Pro-SemiBold', fontSize: 16 }}>
                                           {article.title}
                                       </span> :
                                       <span style={{ fontFamily: 'Source Sans Pro-SemiBold', fontSize: 16 }}>
                                           {`${article.title.substring(0, 80)}...`}
                                       </span>
                               }
                           </a>
                       </CardBody>
                   </Card>
               </div>
           );
       });
    }

    render() {
        const { loading } = this.state;
        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div className="row">
                            <div className="col-1" />
                            <div className="col-10">
                                <div className="row" style={{ paddingTop: 15, paddingLeft: 15 }}>
                                    <div style={{ paddingTop: 5 }}>
                                        <h6 style={{ fontFamily: 'Source Sans Pro-SemiBold' }}>
                                            Showing List of Articles
                                        </h6>
                                    </div>
                                    <div style={{ paddingLeft: 20 }}>
                                        <Link to="/articles/add_articles">
                                            <Button
                                                style={styles.articleButtonStyle}
                                            >
                                               <span style={{ fontSize: 14, fontFamily: 'Source Sans Pro-SemiBold' }}>
                                                  Add Article
                                               </span>
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: 10, paddingBottom: 10 }}>
                                    {this.renderArticles()}
                                </div>
                            </div>
                            <div className="col-1" />
                        </div>
                }
            </div>
        );
    }
}

const styles = {
    articleButtonStyle: {
        width: 100,
        backgroundColor: '#40b508',
        borderWidth: 0,
        height: 32,
        padding: '1px 5px',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    }
};

function mapStateToProps(state) {
    return {
        users: state.login.user,
        articles: state.article.articleData
    };
}

export default connect(mapStateToProps, { fetchArticles })(Articles);



// WEBPACK FOOTER //
// ./src/components/Articles/Articles.js